/**
 * V2-THEME-PLANS U0 — the V2 frame's parts, shared by the sign-in shell and
 * the plan / upgrade screens. See docs/impl/V2-THEME-PLANS/PLAN.md.
 */
export {
  V2_ACCENT,
  V2_MUTE,
  V2_NAV_LINK,
  V2_NAV_PILL,
  V2_OUTLINE_BUTTON,
  V2_PRIMARY_CTA,
  V2_STAGE,
  V2_THEME_TOGGLE,
} from "./classes";
export { V2Accent } from "./v2-accent";
export { V2Footer } from "./v2-footer";
export { V2Nav, type V2NavProps } from "./v2-nav";
export { V2Page, type V2PageProps, type V2PageWidth } from "./v2-page";
export { V2ProofPane, type V2ProofPaneProps } from "./v2-proof-pane";
export { V2Tiles, type V2Tile, type V2TilesProps } from "./v2-tiles";
export { V2TrustRow, type V2TrustRowProps } from "./v2-trust-row";
export { planLimitTiles, type V2ThemeTranslator } from "./plan-limit-tiles";
export { readAuthThemeV2, useAuthThemeV2 } from "./use-auth-theme-v2";
